import {CxEvent} from '@spartacus/core';

export class EddlInitializationEvent extends CxEvent {
  static readonly type = 'EddlInitializationEvent';
}
